import { createFeatureSelector, createSelector } from '@ngrx/store';
import { isActionsReadOnly } from '../user-context.model';
import { UserContextState } from './user-context.state';

export const selectUserContextState = createFeatureSelector<UserContextState>('userContext');

export const selectUserContext = createSelector(selectUserContextState, (state) => state.context);

export const selectUserRole = createSelector(selectUserContext, (context) => context?.role ?? null);

export const selectOrganizationName = createSelector(
  selectUserContext,
  (context) => context?.organizationName ?? null,
);

export const selectOrganizationId = createSelector(
  selectUserContext,
  (context) => context?.organizationId ?? null,
);

export const selectOrganizations = createSelector(
  selectUserContext,
  (context) => context?.availableOrganizations ?? [],
);

export const selectActiveModules = createSelector(
  selectUserContext,
  (context) => context?.activeModules ?? [],
);

export const selectAssignedDataTypes = createSelector(
  selectUserContext,
  (context) => context?.assignedDataTypes ?? [],
);

export const selectAssignedLocationIds = createSelector(
  selectUserContext,
  (context) => context?.assignedLocationIds ?? [],
);

/** The active org has Location Management enabled (false until the context loads). */
export const selectLocationManagementEnabled = createSelector(
  selectUserContext,
  (context) => context?.locationManagementEnabled ?? false,
);

/** An Authorized User with no data type, or no location with Location Management on (false until loaded). */
export const selectAccessRestricted = createSelector(
  selectUserContext,
  (context) => context?.accessRestricted ?? false,
);

/** Employee / Prehire actions are disabled for the signed-in role. */
export const selectActionsDisabled = createSelector(selectUserRole, isActionsReadOnly);

export const selectUserContextLoaded = createSelector(
  selectUserContextState,
  (state) => state.status === 'loaded',
);
